import {Vector2} from './vector'
import {randIntRange, mapRange} from './utils'
import {canvas, colors,   ctx} from './world'

// there is structure within the field. 
// But beyond the structure is the field
// Beyond the story is the dream

// 3d spatial audio of nodes represented as electricity, matched to sounds from web audio api. 
// can prototype with canvas, then use learnings to create a threejs version 

//just like our input senses can recieve energy from the outside, so can our root nodes

//gracefull viz energy moving through graph
class NeuralField{


    constructor() {

        this.rootNode = new Neuron(0, new Vector2(canvas.width/2, canvas.height/2));
        this.rootNode.recieveCharge(1);


        
    }

    update() {
      ctx.save();
      this.rootNode.update();
      ctx.restore();
    }
}

class Neuron {

  constructor(distanceFromRoot, position){

    this.activationEnergy = 1
    this.energy = 0;
    this.numLayers = 7;
    this.baseColor = "white"
    this.color = this.baseColor;
    this.axons = [];
    if (distanceFromRoot >= this.numLayers) {
      return;
    }
    this.active = true;
    this.distanceFromRoot = distanceFromRoot;
    this.position = position;
    this.startingSize = 111;
    
    let distanceFromRootAlpha = mapRange(this.distanceFromRoot, 0, this.numLayers, 0, 1);
    this.size = this.startingSize / (Math.pow(1.77, this.distanceFromRoot))

    for(let i = 0; i < randIntRange(2, 5); i++){
      let xDirection = Math.random() < 0.5 ? -1: 1;
      let yDirection = Math.random() < 0.5 ? -1 : 1;
      let offset = new Vector2(xDirection * this.size * 1.2, yDirection * this.size * 1.2);
      let newNeuronPosition = new Vector2().addVectors(this.position, offset);
      let neuron = new Neuron(this.distanceFromRoot + 1, newNeuronPosition);
      this.axons.push(new Axon(this, neuron));

  
    }
    // a neuron recieves impulse through its dendrites and can be activated at different levels of energy depending on how long it's been in refractory period,
    // how new the neuron is, what the surrounding environment is like.. etc
  }

  // everything still has to update and draw, so thats different then flow
update() {
  if(!this.active) {
    return;
  }
  this.draw();
  this.axons.forEach((axon) => {
    axon.update()
  })
}

  recieveCharge(energy) {
    this.energy += energy;
    if(this.energy > this.activationEnergy) {
      this.releaseCharge()
    }
  }

  
  
  // Charge is released when neuron passes it activation energy threshold
  //linked to audio in resonance)
  // How it distributers its charge amongst is axons is a function that can be played with, swapped out, etc ? (sounds cool..)
  // axon can shoot a charge all at once or have it flow over time

  releaseCharge() {
    // can meter out energy over time or just blast it all at once ...
    let axonEnergy = this.energy * 0.5
    this.color = "green";
    console.log(axonEnergy)
    this.axons.forEach((axon) => {
      axon.flow(axonEnergy);
      
    });
    this.energy = 0;

    // setTimeout(()=>{
    //   //this.color = this.baseColor;
      
    // }, 1000)


    // distribute energy to all axons equally for now
  }

  draw(){
    if(!this.position) {
      return;
    }
    ctx.fillStyle = this.color;
    ctx.fillRect(this.position.x, this.position.y, this.size, this.size );
  }

}
 
// axons are the connections between neurons. They can transmit energy. Some axons are larger and can transmit more than others 
// The energy they transmit are actually little particles - an action potential- a rushing wave of sodium and magnesium? Potassium?
// this wave of energy reaches the end and then releases its neurotransmitters into a gap where a dendrite on another neuron is activated
// 

class Axon{
  constructor(sourceNeuron, recieverNeuron) {
    this.sourceNeuron = sourceNeuron;
    this.recieverNeuron = recieverNeuron;
  }

  flow(energy) {
    // send energy to my neuron
    this.recieverNeuron.recieveCharge(energy);
  }

  update() {
    this.draw()
    this.recieverNeuron.update();
  }

  draw(){


  }

}

export {NeuralField}